import BaseEntityAutocompleteOrCreate, {
  AutocompleteType,
  BaseEntityAutocompleteOrCreateInheritableProps,
} from "@/common/components/Entity/components/BaseEntityAutocompleteOrCreate";
import { SpotDto } from "@/core/api/generated/v1";

import SpotAutocomplete, { SpotAutocompleteProps } from "./SpotAutocomplete";
import SpotCreateUpdate, { SpotCreateUpdateProps } from "./SpotCreateUpdate";
import SpotCreateUpdateModal from "./SpotCreateUpdateModal";

type Props = BaseEntityAutocompleteOrCreateInheritableProps<
  SpotDto,
  SpotCreateUpdateProps["defaultValues"],
  SpotAutocompleteProps,
  SpotCreateUpdateProps
>;

export default function SpotAutocompleteOrCreate({ ...otherProps }: Props) {
  return (
    <BaseEntityAutocompleteOrCreate<
      SpotDto,
      SpotCreateUpdateProps["defaultValues"],
      SpotAutocompleteProps,
      SpotCreateUpdateProps
    >
      autocompleteType={AutocompleteType.Single}
      getDefaultValues={(params) => params.createUpdateProps?.defaultValues}
      renderAutocomplete={(params) => (
        <SpotAutocomplete
          {...params.autocompleteProps}
          withCreate
          createOptionTitle={(inputValue) => `Create new spot "${inputValue}"`}
          onCreate={(newOption) => {
            params.setDefaultValues({
              ...params.defaultValues,
              name: newOption?.inputValue || params.defaultValues?.name || undefined,
            });
            params.setIsCreate(true);
            params.onCreateStart && params.onCreateStart();
          }}
        />
      )}
      renderCreateUpdate={(params) => (
        <SpotCreateUpdate
          {...params.createUpdateProps}
          defaultValues={params.defaultValues}
          onCreate={params.onCreate}
          onSave={(newValue) => {
            params.setIsCreate(false);
          }}
        />
      )}
      renderCreateUpdateModal={(params) => (
        <SpotCreateUpdateModal
          open={params.isCreate}
          onClose={() => params.setIsCreate(false)}
          createUpdateProps={{
            ...params.createUpdateProps,
            defaultValues: params.defaultValues,
            onCreate: params.onCreate,
            onSave: (newValue) => {
              params.setIsCreate(false);
            },
          }}
        />
      )}
      {...otherProps}
    />
  );
}
